import type React from "react";
import { SamplesPage } from "routes/samples/SamplesPage/SamplesPage";

const SamplesPageContainer: React.VFC = () => {
  return <SamplesPage />;
};

export default SamplesPageContainer;
